/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Faint_Fast_Lark_PlayInputs */

const en_faint_fast_lark_play = /** @type {(inputs: Faint_Fast_Lark_PlayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Errors (${i?.count})`)
};

const de_faint_fast_lark_play = /** @type {(inputs: Faint_Fast_Lark_PlayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Fehler (${i?.count})`)
};

/**
* | output |
* | --- |
* | "Errors ({count})" |
*
* @param {Faint_Fast_Lark_PlayInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const faint_fast_lark_play = /** @type {((inputs: Faint_Fast_Lark_PlayInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faint_Fast_Lark_PlayInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_faint_fast_lark_play(inputs)
	return de_faint_fast_lark_play(inputs)
});